import { IFirmTaxprepT1Card } from "./ifirm-taxprep-t1-card";
import { JobsBillingCard } from "./jobs-billing-card.interface";
import { TaxprepT1Card } from "./taxprep-t1-card";

export type IBaseCard = JobsBillingCard | TaxprepT1Card | IFirmTaxprepT1Card;
export type IBaseT1Card = TaxprepT1Card | IFirmTaxprepT1Card;

export enum EfileStatus {
    NotApplicable = 0,
    NotEligible = 1,
    Eligible = 2,
    Accepted = 3,
    Rejected = 4,
}
